import { FunctionComponent, ReactNode } from 'react';
import { Popover } from '@headlessui/react';
import { cn, getAssetSrc, useNavigationContext } from '@restworld/utils-common';
import { Logo } from '@restworld/ui-ds-base';

export const FooterMainGrid = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-6', className)} {...props} />
);
export const FooterColumnGroup = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-4', className)} {...props} />
);
export const FooterColumnTitle = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <p className={cn('font-semibold', className)} {...props} />
);
export const FooterColumnItemGroup = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-2', className)} {...props} />
);

export const FooterColumnItem: FunctionComponent<{
  href?: string;
  comingSoon?: boolean;
  newWindow?: boolean;
  children: ReactNode;
}> = ({ href, children, comingSoon, newWindow }) => {
  const { linkComponent: Link } = useNavigationContext();
  if (comingSoon)
    return (
      <Popover className="relative">
        <Popover.Button className="font-normal text-left">{children}</Popover.Button>
        <Popover.Panel className="absolute z-10 bg-black text-white rounded-xl p-3">
          <p>Coming soon ;)</p>
        </Popover.Panel>
      </Popover>
    );
  if (newWindow)
    return (
      <a href={href} className="font-normal" target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  return (
    <Link href={href} className="font-normal" {...{ locale: '' }}>
      {children}
    </Link>
  );
};

const SocialIcon = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('w-6', className)} {...props} />
);

export const LogoAndSocials: FunctionComponent = () => {
  const { linkComponent: Link } = useNavigationContext();

  return (
    <div className="flex flex-col gap-4">
      <div>
        <Link href="/">
          <div className="mr-3">
            <Logo variant="horizontal" title="restworld" className="h-9 w-auto text-purple-700" />
          </div>
        </Link>
      </div>
      <SocialIcons />
    </div>
  );
};

const SmartAndStartLogo = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex justify-center w-8/12 md:w-full', className)} {...props} />
);

export const SmartAndStartLogos: FunctionComponent = () => (
  <div className="flex justify-center">
    <div className="flex flex-col md:flex-row md:w-1/2 gap-10 my-10 justify-center items-center">
      <SmartAndStartLogo>
        <img src={getAssetSrc('/utils-assets/smart-and-start/ue.svg')} alt="Smart and Start UE logo" />
      </SmartAndStartLogo>
      <SmartAndStartLogo>
        <img src={getAssetSrc('/utils-assets/smart-and-start/start.svg')} alt="Smart and Start logo" />
      </SmartAndStartLogo>
      <SmartAndStartLogo>
        <img src={getAssetSrc('/utils-assets/smart-and-start/imprese.svg')} alt="Ministero delle imprese logo" />
      </SmartAndStartLogo>
    </div>
  </div>
);
export const SocialIcons = () => (
  <div className="flex flex-row gap-5">
    <SocialIcon>
      <a href="https://www.facebook.com/restworld.it" target="_blank" rel="noreferrer">
        <img src={getAssetSrc('/utils-assets/social-icons/facebook.svg')} className="mr-3 h-8" alt="Facebook" />
      </a>
    </SocialIcon>
    <SocialIcon>
      <a href="https://www.instagram.com/restworld_hr/" target="_blank" rel="noreferrer">
        <img src={getAssetSrc('/utils-assets/social-icons/instagram.svg')} className="mr-3 h-8" alt="Instagram" />
      </a>
    </SocialIcon>
    <SocialIcon>
      <a href="https://www.linkedin.com/company/restworld" target="_blank" rel="noreferrer">
        <img src={getAssetSrc('/utils-assets/social-icons/linkedin.svg')} className="mr-3 h-8" alt="Linkedin" />
      </a>
    </SocialIcon>
    <SocialIcon>
      <a href="https://t.me/restworld_offerte" target="_blank" rel="noreferrer">
        <img src={getAssetSrc('/utils-assets/social-icons/telegram.svg')} className="mr-3 h-8" alt="Telegram" />
      </a>
    </SocialIcon>
  </div>
);
export const Divider = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <hr className={cn('', className)} {...props} />
);

export const CopyrightContainer = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('my-10 font-normal text-gray-500 text-justify md:text-center', className)} {...props} />
);
